import '../typography/index'
import OCTRenderQueue from '../../plugins/oct-render-queue'
import OCTScrollIntoView from '../scroll-into-view/index'
import './oct-section-lead.scss'

document.addEventListener('DOMContentLoaded', event => { // eslint-disable-line no-unused-vars
  // set scroll into view
  Array.from(document.querySelectorAll('.oct-section-lead__text[data-show="on-scroll"]')).forEach(el => {
    const offset = +(el.getAttribute('data-offset') || .2)

    new OCTScrollIntoView(el, {
      offset: isNaN(offset) ? 0 : offset
    })
  })

  OCTRenderQueue.flush()

  if (process.env.NODE_ENV === 'development')
    console.info('[OCT] Intializing OCTContentLead...')
})
